export default __webpack_public_path__ + "static/media/no-foto.22d7f1c8.png";